{
  "client": "Client",
  "marketValue": "Total des actifs",
  "completedAt": "Terminé à",
  "organization": "Organisation",
  "previousInformationUpdate": "Mise à jour des renseignements précédents",
  "daysPastDue": "Jours d'arriéré",
  "search": "Recherche",
  "days": "jours",
  "table": {
    "organization": "Organisation"
  }
}
